import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import { Button, Grid, TextField, Typography } from '@mui/material'
import { FastField, FieldArray, FieldProps } from 'formik'

import useStyles from './index.styles'

interface IProps {
  notes: INoteType[]
}

interface INoteType {
  header: string
  content: string
}

const NotesSections = ({ notes }: IProps) => {
  const classes = useStyles

  return (
    <FieldArray name="notes">
      {(arrayHelpers) => (
        <div>
          {notes &&
            notes.length > 0 &&
            notes.map((item: INoteType, index: number, arr: INoteType[]) => (
              <Grid container={true} spacing={2} key={index}>
                <Grid
                  container={true}
                  size={12}
                  sx={[
                    {
                      justifyItems: 'center',
                    },
                    classes.headerGrid,
                  ]}
                >
                  <Typography variant="body1">
                    Section {index + 1}
                    {notes.length > 1 && (
                      <Button onClick={() => arrayHelpers.remove(index)} aria-label="Remove" sx={classes.removeSectionBtn} size="small">
                        Remove
                      </Button>
                    )}
                  </Typography>
                </Grid>

                <Grid size={12}>
                  <FastField name={`notes.${index}.header`}>
                    {({ field }: FieldProps) => {
                      const label = 'Section Header'

                      return (
                        <div>
                          <TextField
                            {...field}
                            value={field.value}
                            fullWidth={true}
                            slotProps={{
                              htmlInput: {
                                'aria-label': label,
                                'aria-labelledby': `${field.name}-header-label`,
                              },
                            }}
                            variant="outlined"
                            label={label}
                          />
                        </div>
                      )
                    }}
                  </FastField>
                </Grid>

                <Grid size={12}>
                  <FastField name={`notes.${index}.content`}>
                    {({ field }: FieldProps) => {
                      const label = 'Content'

                      return (
                        <div>
                          <TextField
                            {...field}
                            variant="outlined"
                            fullWidth={true}
                            multiline={true}
                            placeholder="Describe the feature"
                            minRows={5}
                            label={label}
                            slotProps={{
                              input: {
                                'aria-label': label,
                                'aria-labelledby': `${field.name}-content-label`,
                              },
                            }}
                          />
                        </div>
                      )
                    }}
                  </FastField>
                </Grid>

                {index + 1 === arr.length && (
                  <Grid
                    container={true}
                    size={12}
                    sx={{
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => arrayHelpers.push({ header: '', content: '' })}
                      aria-label="Add New Section"
                      size="small"
                      startIcon={<AddOutlinedIcon />}
                    >
                      New Section
                    </Button>
                  </Grid>
                )}
              </Grid>
            ))}
        </div>
      )}
    </FieldArray>
  )
}

export default NotesSections
